var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        title: _vm.$t("pc_gwnl_eval_selectDepartment"),
        visible: _vm.dialogVisible,
        size: "960px",
        "before-close": _vm.beforeDrawClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _vm.dialogVisible
        ? [
            _c("yxtbiz-range-selector", {
              ref: "selector",
              attrs: {
                tabs: _vm.tabs,
                "function-code": _vm.functionCode,
                "data-permission-code": _vm.dataPermissionCode,
                enableGroupCorp: _vm.enableGroupCorp,
                visibleOrgSelector: _vm.visibleOrgSelector,
              },
              model: {
                value: _vm.selectedDepts,
                callback: function ($$v) {
                  _vm.selectedDepts = $$v
                },
                expression: "selectedDepts",
              },
            }),
          ]
        : _vm._e(),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("yxt-button", { on: { click: _vm.beforeDrawClose } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("pc_gwnl_global_btn_cancel")) +
                "\n    "
            ),
          ]),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_gwnl_global_btn_confirm")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }